import { z } from "zod/v4";

import { JSONValueSchema, LanguageModelSchema } from "../common";
import { AiNodeContextSchema } from "../context-schemas";
import { BaseNodeExecutionResultSchema } from "../node-execution-result";

import { BaseNodeDefinitionSchema } from "./base-node";
import { ToolResultSchema } from "./tool-result";

export const ToolExecutionNodeResultSchema =
  BaseNodeExecutionResultSchema.extend({
    type: z.literal("tool-execution"),
    result: ToolResultSchema,
    updatedContext: AiNodeContextSchema,
  });

export const BaseToolExecutionNodeConfigSchema = z.object({
  model: LanguageModelSchema.optional(),
});

export const ToolExecutionNodeConfigSchema =
  BaseToolExecutionNodeConfigSchema.extend({
    toolId: z.string(),
    toolName: z.string(),
    timeout: z.number().optional(),
    args: z.record(z.string(), JSONValueSchema),
  });

export const ToolExecutionNodeDefinitionSchema =
  BaseNodeDefinitionSchema.extend({
    type: z.literal("tool-execution"),
    config: ToolExecutionNodeConfigSchema,
  });

export type ToolExecutionNodeResult = z.infer<
  typeof ToolExecutionNodeResultSchema
>;
export type ToolExecutionNodeConfig = z.infer<
  typeof ToolExecutionNodeConfigSchema
>;
export type ToolExecutionNodeDefinition = z.infer<
  typeof ToolExecutionNodeDefinitionSchema
>;
